export enum ArticleFields {
    None = 0,
    ShortContent = 1,
    Images = 2,
    Issue = 4,
    Publication = 8,
    Paragraphs = 16,
    Related = 32,
    Similars = 64,
    Access = 128,
    Comments = 256,
    Votes = 512,
    AnalyticProfiles = 1024,
    Classification = 2048,
    Summary = 4096,
}

// a bitmask enum representing which fields of an article are available.
export enum ArticleMetadataFields {
    Language = 1,
    OriginalLanguage = 2,
    Issue = 4,
}
